



























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import { Address, OrgsApi, Product, ProductsApi, ProductSubtype, ProductType, Site } from '@/api';
import { feedProductSubtypeOptions } from '@/pages/account/products/feed/models';
import { Constants } from '@/common/Constants';
import addBilling from '@/components/add business objects/addBilling.vue';
import Toast from '@/components/display/toast.vue';
import orgSuggest from '@/components/form pickers/orgSuggest.vue';
import siteSuggest from '@/components/form pickers/siteSuggest.vue';
import BillingSetupForm from '@/components/billing-setup-form/billing-setup-form.vue';
import { mixins } from 'vue-class-component';
import { Validation, validationMixin } from 'vuelidate';
import { Validations } from 'vuelidate-property-decorators';
import { integer, required, requiredIf } from 'vuelidate/lib/validators';
import { AxiosError } from 'axios';
import { simproJobZones } from '@/models/simpro-job-zones';

@Component({
	components: {
		orgSuggest,
		siteSuggest,
		addBilling,
		secondaryNav,
		vSelect,
		Toast,
		BillingSetupForm,
	},
})
export default class AddProductForm extends mixins(validationMixin) {
	public readonly productTypes = [
		{ value: Constants.PRODUCT_TYPE_MILK, text: 'Milk' },
		{ value: Constants.PRODUCT_TYPE_FUEL, text: 'Fuel' },
		{ value: Constants.PRODUCT_TYPE_WATER, text: 'Water' },
		{ value: Constants.PRODUCT_TYPE_EFFLUENT, text: 'Effluent' },
		{ value: ProductType.Feed, text: 'Feed' },
	];
	public readonly feedSubtypeOptions = feedProductSubtypeOptions;
	public readonly zoneOptions = simproJobZones['New Zealand'];
	public loading = true;
	public creatingProduct = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public createdProduct: Product | null = null;

	public product = {
		orgId: null,
		siteId: null,
		type: Constants.PRODUCT_TYPE_MILK,
		farmSourceRegion: null,
		fonterraCaseId: null,
		supplier: null,
		supplierNumber: null,
		subtype: ProductSubtype.Feed,
	};
	public suppliers: Record<string, string>[] = [];

	@Validations()
	public validations() {
		return {
			org: {
				id: { required },
				name: { required },
				subscription: {
					id: { required },
				},
			},
			site: {
				id: { required },
				name: { required },
				address: { fullAdr: { required } },
			},
			product: {
				type: { required },
				supplierNumber: {
					String,
					required: requiredIf(() => this.product.type === 'milk'),
				},
				farmSourceRegion: {
					required: requiredIf(() => this.product.type === 'milk' && this.product.supplier === 'F'),
				},
			},
		};
	}

	public org = {
		id: undefined,
		name: '',
		adminId: undefined,
		admin: { id: '', name: '', phone: '', email: '' },
		sites: [],
		address: { fullAdr: '', region: '' },
		tradingName: null,
		subscription: {
			id: undefined,
			paymentMethod: '',
			accountApproved: false,
			paymentMethodActive: false,
			directDebitDate: '',
			accountName: '',
			accountNumber: '',
		},
		activeSiteId: '',
		farmSourceRegion: '',
	};

	public site: Site & { address: Address } = {
		id: undefined,
		orgId: undefined,
		name: '',
		address: { fullAdr: '', region: '' },
	};

	@Watch('product.type')
	public async onTypeChanged() {
		this.product.supplier = null;
		this.product.farmSourceRegion = null;
		this.product.fonterraCaseId = null;
		this.product.subtype = ProductSubtype.Feed;
		this.$v.$reset();
	}

	public isValid(field: Validation) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public async load() {
		const orgId = this.org.id == null ? this.$route.params.orgId : this.org.id;
		if (orgId !== undefined) {
			this.submitStatus = 'OK';
			this.loading = true;
			try {
				const response = await new OrgsApi().getOrgById(parseInt(orgId, 10), [
					'admin',
					'address',
					'sites',
					'subscription',
				]);
				(this.org as any) = response.data;
			} catch (e) {
				console.log(e);
			} finally {
				this.loading = false;
			}
		} else {
			this.loading = false;
		}
		await this.fetchSuppliers();
	}

	public async created() {
		await this.load();
	}

	public onProductCreated(product: Product | null): void {
		this.createdProduct = product;
		(this.$refs.wizard as Vue & { nextTab: () => void }).nextTab();
	}

	private async fetchSuppliers(): Promise<void> {
		try {
			let response = await new OrgsApi().orgGetPartnersByProductType('milk');
			this.suppliers = (response?.data?.data ?? [])
				.map(supplier => {
					return {
						text: supplier.name ?? '',
						value: supplier.supplierCode ?? '',
					};
				})
				.sort((a, b) => a.text.localeCompare(b.text));
		} catch (errorResponse) {
			const error = errorResponse as AxiosError;
		}
	}

	public async onBillingSetupComplete(): Promise<void> {
		await this.$router.push({
			name: `products.${this.createdProduct!.type}.view`,
			params: {
				productId: this.createdProduct!.id!.toString(),
			},
		});
	}
	public stepValidate() {
		const form = this.$v;
		form.$touch();
		if (!form.$invalid) {
			this.createProduct();
		}
	}

	public async createProduct() {
		this.creatingProduct = true;
		this.submitStatus = 'PENDING';
		let product;
		let createdProduct;
		if (this.product.type === 'milk') {
			product = {
				type: this.product.type,
				orgId: this.org.id,
				siteId: this.site.id,
				supplierNumber: this.product.supplierNumber,
				fonterraCaseId: this.product.fonterraCaseId,
				supplier: this.product.supplier,
				fssRegion: this.product.farmSourceRegion,
			};
		} else if (this.product.type === ProductType.Feed) {
			product = {
				type: this.product.type,
				orgId: this.org.id,
				siteId: this.site.id,
				subtype: this.product.subtype,
			};
		} else {
			product = {
				type: this.product.type,
				orgId: this.org.id,
				siteId: this.site.id,
			};
		}

		try {
			const promise = await new ProductsApi().storeProduct({ data: product });
			createdProduct = promise.data.data;
		} catch (e) {
			const axiosError = e as AxiosError;
			let error;
			if (axiosError.response) {
				error = JSON.stringify(axiosError.response.data.errors, null, 2);
			} else {
				error = 'product not created, unknown Error';
			}
			new Toast().makeToast(error, 'Error Adding Product', 'danger', true);
			this.submitStatus = 'ERROR';
			this.creatingProduct = false;
			return;
		}
		this.submitStatus = 'OK';
		new Toast().makeToast('Product Added', 'Product Added', 'success', true);
		if (createdProduct) {
			this.createdProduct = createdProduct;
		}
		(this.$refs.wizard as Vue & { nextTab: () => void }).nextTab();
		this.creatingProduct = false;
	}
}
